module.exports = __webpack_public_path__ + "img/pro_beijia_04.998aa5a5.png";